import React from 'react';
import { ArticleCard } from '../article/ArticleCard';
import { featureArticleHref, resolveFeatureCardHeroProps } from '../../lib/featureArticles';
import type { ArticleRow } from '../../../../shared/schemas/article';

interface FeatureArticleSmallProps {
  article: ArticleRow;
  variant?: 'featured' | 'compact';
}

export function FeatureArticleSmall({ article, variant = 'featured' }: FeatureArticleSmallProps) {
  const { heroMedia, miniDemoId } = resolveFeatureCardHeroProps(article);

  return (
    <ArticleCard
      title={article.title}
      excerpt={article.excerpt ?? ''}
      slug={article.slug}
      href={featureArticleHref(article.slug)}
      heroMedia={heroMedia ?? undefined}
      miniDemoId={miniDemoId}
      variant={variant}
    />
  );
}
